/**
 * Open state for the command palette, and the shortcut that opens it.
 *
 * Kept out of CommandPalette.svelte so knowing whether the palette is open does
 * not require having downloaded it: App.svelte binds the shortcut from here and
 * fetches the component only once something has asked for it.
 */

const state = $state({ open: false, everOpened: false })

export const commandPaletteState = () => state

export function openCommandPalette() {
  state.open = true
  state.everOpened = true
}

export function closeCommandPalette() {
  state.open = false
}

/** Bind the palette's shortcut. Returns a teardown for `$effect`. */
export function bindCommandPaletteShortcut() {
  function onKey(event) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault()
      if (state.open) closeCommandPalette()
      else openCommandPalette()
    }
  }
  window.addEventListener('keydown', onKey)
  return () => window.removeEventListener('keydown', onKey)
}
